var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/close-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5867 2.6665H10.4134C5.56002 2.6665 2.66669 5.55984 2.66669 10.4132V21.5732C2.66669 26.4398 5.56002 29.3332 10.4134 29.3332H21.5734C26.4267 29.3332 29.32 26.4398 29.32 21.5865V10.4132C29.3334 5.55984 26.44 2.6665 21.5867 2.6665ZM20.48 19.0665C20.8667 19.4532 20.8667 20.0932 20.48 20.4798C20.28 20.6798 20.0267 20.7732 19.7734 20.7732C19.52 20.7732 19.2667 20.6798 19.0667 20.4798L16 17.4132L12.9334 20.4798C12.7334 20.6798 12.48 20.7732 12.2267 20.7732C11.9734 20.7732 11.72 20.6798 11.52 20.4798C11.1334 20.0932 11.1334 19.4532 11.52 19.0665L14.5867 15.9998L11.52 12.9332C11.1334 12.5465 11.1334 11.9065 11.52 11.5198C11.9067 11.1332 12.5467 11.1332 12.9334 11.5198L16 14.5865L19.0667 11.5198C19.4534 11.1332 20.0934 11.1332 20.48 11.5198C20.8667 11.9065 20.8667 12.5465 20.48 12.9332L17.4134 15.9998L20.48 19.0665Z",
    fill: "#BA0060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.68fc0e8d4500639a1081eaea3bbbf212.svg";
export { ForwardRef as ReactComponent };